module Factive.Game
{
    "use strict"

    // ========================= Object =========================
    export class AnalyticsConstants
    {
        public static FIVE_ROLL_PIXI:string = "five_roll_pixi";
        public static TOPIC_ANALYTIC:string = "analytic";

        public static ACTION_START:string = "start";
        public static ACTION_SUBMIT:string = "submit";
        public static ACTION_QUIT:string = "quit";
        public static ACTION_UNDO:string = "undo";
        public static ACTION_ZERO:string = "zero";
        public static ACTION_SCORE_500:string = "score_500";
        public static ACTION_SCORE_1000:string = "score_1000";
        public static ACTION_SCORE_1500:string = "score_1500";
        public static ACTION_SCORE_2000:string = "score_2000";
        public static ACTION_SCORE_2500:string = "score_2500";
        public static ACTION_SCORE_MORE_2500:string = "score_more_2500";
        public static ACTION_HELP:string = "help";
        public static ACTION_COLOR:string = "color";
        public static ACTION_COLOR_1:string = "color1";
        public static ACTION_COLOR_2:string = "color2";
        public static ACTION_COLOR_3:string = "color3";
        public static ACTION_SOUND_ON_CLICK:string = "sound_on_click";
        public static ACTION_SOUND_OFF_CLICK:string = "sound_off_click";
        public static ACTION_ABANDON:string = "abandon";
        public static ACTION_5_ROLL:string = "5roll";
        public static ACTION_TOTAL_ROLLS:string = "total_rolls";
        public static ACTION_QUIT_ROLLS:string = "quit_rolls";
        public static ACTION_TIME_WIN:string = "time_win";
        public static ACTION_TIME_QUIT:string = "time_quit";
    }
}



// WEBPACK FOOTER //
// src/typescript/Game/Analytics/AnalyticsConstants.ts